import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '393287515084';
  const defaultMessage = "Buongiorno Mauro, vorrei richiedere un'analisi assicurativa e maggiori informazioni sulle coperture per medici.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contatta Mauro Astore su WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white p-3.5 sm:px-5 sm:py-3.5 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 group border-2 border-white/30"
    >
      <MessageCircle size={28} className="fill-white text-[#25D366] shrink-0" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs transition-all duration-500 ease-in-out font-semibold text-sm sm:text-base tracking-wide sm:max-w-none">
        Parla subito con Mauro
      </span>
    </a>
  );
};

export default WhatsAppButton;
